(function () {
    'use strict';

    angular
        .module('app.cart.payment', [])

        .directive('cartPayment', function () {
            return {
                restrict: 'A',
                bindToController: {
                    device: '<',
                    step: '<',
                    list: '<?',
                    link: '@?'
                },
                controllerAs: 'cartCtrl',
                /* @ngInject */
                controller: ["$scope", "$rootScope", "$element", "AppService", "CartService", "RoutesService", "PaymentService", function ($scope, $rootScope, $element, AppService, CartService, RoutesService, PaymentService) {
                    var ctrl = this;
                    ctrl.NextEnabled = false;
                    var _routes = RoutesService.get();
                    ctrl.nextStep = '/' + _routes.CartValidation.url;

                    // Translate
                    var tplTranslate = {};
                    $element.children('.translate').children().each(function () {
                        var $this = $(this);
                        tplTranslate[$this.attr('key')] = $this.html();
                    });

                    ctrl.NextTooltip = tplTranslate.NextTooltip;

                    ctrl.$onInit = function () {
                        if (ctrl.step !== 0) {
                            getCart();
                        } else {
                            ctrl.payment = {
                                paymentList: ctrl.list
                            };
                            _.each(ctrl.payment.paymentList, function (item) {
                                item.imgSrc = '/img/payment/' + _.camelCase(item.Key) + '.png';
                                item.Selected = false;
                            });
                        }
                    };

                    // Cart Aside
                    ctrl.toggleCart = function () {
                        CartService.toggleCart(ctrl);
                    };
                    ctrl.toggleUpdate = function (model) {
                        CartService.toggleUpdate(ctrl, model);
                    };
                    ctrl.submitCode = function (event) {
                        if (String(ctrl.formCode.data.code) === '') return;
                        $(event.target).find('.form-control').blur();
                        CartService.submitCode(ctrl);
                    };
                    ctrl.cancelCode = function (code) {
                        CartService.cancelCode(ctrl, code);
                    };
                    ctrl.addLoyaltyPoint = function () {
                        CartService.addLoyaltyPoint(ctrl);
                    };
                    ctrl.cancelLoyaltyPoint = function () {
                        CartService.cancelLoyaltyPoint(ctrl);
                    };
                    ctrl.useCredit = function (id) {
                        CartService.useCredit(ctrl, id);
                    };
                    ctrl.cancelCredit = function (id) {
                        CartService.cancelCredit(ctrl, id);
                    };
                    ctrl.cancelGiftCard = function (code) {
                        CartService.cancelGiftCard(ctrl, code);
                    };
                    // End Cart Aside


                    ctrl.selectItem = function (item, autoSelect) {
                        autoSelect = autoSelect || false;

                        if (!autoSelect && item.Selected) return;


                        ctrl.NextEnabled = true;
                        ctrl.NextTooltip = '';

                        _.each(ctrl.payment.paymentList, function (payment) {
                            payment.Selected = false;
                            payment.loading = false;
                        });
                        item.Selected = true;
                        ctrl.itemSelected = { item: item };
                        if (!autoSelect && ctrl.step !== 0) selectPayment(item);

                        if (ctrl.step === 0) {
                            ctrl.nextStep = ctrl.link + item.IDPaymentMethod;
                        }
                    };

                    // Events

                    $scope.$on('cartUpdate', function () {
                        if (ctrl.step !== 0) {
                            getCart();
                        }
                    });

                    // Functions

                    function getPaymentList() {
                        ctrl.loading = true;
                        PaymentService.getList()
                            .then(function (response) {
                                if (response.status === 'OK') {
                                    ctrl.payment = response.results;

                                    _.each(ctrl.payment.paymentList, function (item) {
                                        item.imgSrc = '/img/payment/' + _.camelCase(item.Key) + '.png';
                                        if (ctrl.cart.PaymentMethod) {
                                            if (item.IDPaymentMethod === ctrl.cart.PaymentMethod.IDPaymentMethod) ctrl.selectItem(item, true);
                                        }
                                    });
                                } else {
                                    console.error(response.status);
                                }
                                ctrl.loading = false;
                            })
                            .catch(function (error) {
                                console.error(error);
                            });
                    }

                    function getCart() {
                        AppService.getParams()
                            .then(function (data) {
                                CartService.update(ctrl, data, true);
                                CartService.updateStepsCart(ctrl);
                                if (!ctrl.itemSelected) {
                                    ctrl.NextEnabled = false;
                                }
                                if (ctrl.cart.RestToPay === 0) {
                                    ctrl.NextEnabled = true;
                                }
                                getPaymentList();
                            })
                            .catch(function (error) {
                                console.error(error);
                            });
                    }

                    function selectPayment(item) {
                        $rootScope.$broadcast('showPageLoader', true);
                        PaymentService.selectPayment(item)
                            .then(function (response) {
                                if (response.status === 'OK') {
                                    if (ctrl.step !== 0) {
                                        CartService.update(ctrl, response.results);
                                    }
                                }
                                $rootScope.$broadcast('showPageLoader', false);
                            })
                            .catch(function (error) {
                                console.error(error);
                            });
                    }

                }]
            };
        });

})();
